var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"radio","id":_vm.inputId,"name":_vm.inputName},domProps:{"checked":_vm.inputChecked,"value":_vm.inputValue},on:{"input":_vm.setInput}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.inputLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }